function ConvertObjectToFormData(formData, data, name = "") {
    if (data instanceof Array) {
      data.forEach((value, index) => ConvertObjectToFormData(formData, value, `${name}[${index}]`))
    }
    else if (data instanceof File) {
      formData.append(name.substring(0, name.indexOf("[")), data)
    }
    else if (data instanceof Object) {
      Object.keys(data).forEach(key => ConvertObjectToFormData(formData, data[key], `${name}${name ? '.' : ''}${key}`))
    }
    else if(data != null){
      formData.append(name, data)
    }
}

export default ConvertObjectToFormData